import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "actions"
  }, _vm._l(_vm.rowActions.slice().map(x => {
    return x.evaluate(_vm.row);
  }), function (action, aIndex) {
    return _c('div', {
      key: aIndex,
      staticClass: "d-inline",
      attrs: {
        "data-toggle": "tooltip",
        "data-placement": "top",
        "data-title": action.reason ? action.reason : action.label,
        "data-original-title": action.reason ? action.reason : action.label,
        "data-html": "true"
      }
    }, [_c('button', {
      staticClass: "btn icon",
      attrs: {
        "type": "button",
        "disabled": action.disabled || _vm.locked
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('row-action', {
            index: _vm.rowIndex,
            row: _vm.row,
            name: action.name
          });
        }
      }
    }, [_c('i', {
      class: action.icon
    })])]);
  }), 0);
};
var staticRenderFns = [];
export { render, staticRenderFns };